import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { globalFontStyle } from "../../../assets";
import { isMobile } from "../../../utils/commonMethods";
import ProbeIcon from "../../../commonComponents/ProbeIcon";
import Colors from "../../../assets/Color/Colors";
import {globalConfigurableData} from "../../../utils/globalConstant";

const TitleComponent = ({ eventInfo }) => {
  return (
    <View>
      {isMobile() && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            paddingHorizontal: 15,
            marginBottom: 15,
            // paddingBottom: 15,
          }}
        >
          <View style={{ flexDirection: "row", flex: 1 }}>
            <ProbeIcon 
              eventUrl={eventInfo?.imageurl} 
              subcategory={eventInfo?.subcategory}
            />
            <View style={{ 
              flex: 1, 
              flexDirection: 'column', 
              alignSelf: 'center',
              justifyContent: (eventInfo?.alternate_title || eventInfo?.subtitle) ? 'flex-start' : 'center'
            }}>
              <Text
                  numberOfLines={2}
                  style={[globalFontStyle.appFontHeading, styles.eventTitle]}
              >
                {eventInfo?.title}
              </Text>
              {(eventInfo?.alternate_title || eventInfo?.subtitle) && (
                <Text
                    style={[
                      globalFontStyle.appFontBody,
                      { color: globalConfigurableData.secondaryTextColor1, marginLeft: 15,},
                    ]}
                    numberOfLines={1}
                >
                  {eventInfo?.alternate_title ? eventInfo?.alternate_title : eventInfo?.subtitle}
                </Text>
              )}
            </View>
          </View>
        </View>
      )}
    </View>
  );
};

export default TitleComponent;

const styles = StyleSheet.create({
  eventTitle: {
    flex: 1,
    marginLeft: 15,
    color: globalConfigurableData.primaryTextColor1
  },
});
